import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';
import { fade, makeStyles, withStyles } from '@material-ui/core/styles';
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';
import Collapse from '@material-ui/core/Collapse';
import { useRef, useEffect, useState, useCallback, memo } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Slider from '@material-ui/core/Slider';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        flexDirection: "column",
        whiteSpace: "nowrap"
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    accordionDetailsRoot: {
        padding: "1px 2px 2px"
    },
    sliderRoot: {
        margin: "30px 15px 2px 30px",
        width: "100%",
        width: "-moz-available",
        width: "-webkit-fill-available",
        width: "fill-available",
    }
}));

const FilterBar2 = ({ filterData, setFilter }) => {
    const classes = useStyles();
    
    console.log("filterbar2");
    if (filterData != null && filterData.filters != null) {
        return (
            <>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography className={classes.heading}>Advanced Filters</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.root}>
                        {filterData.filters.children.map((data, i) => {
                            return (
                                <Accordion key={i}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={classes.heading}>{data.displayText}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails className={classes.accordionDetailsRoot}>
                                        <ButtonGroup className={classes.root} color="secondary" size="small" aria-label="small outlined secondary button group">
                                            {data.children.map((data2, i2) => {
                                                return (
                                                    <Button key={i2}
                                                        style={{ alignSelf: "flex-start" }}
                                                        onClick={() => setFilter(filters => [...filters, data2])}
                                                    >
                                                        {`${data2.displayText} (${data2.count})`}
                                                    </Button>
                                                )
                                            })}
                                        </ButtonGroup>
                                    </AccordionDetails>
                                </Accordion>
                            )
                        })}
                    </AccordionDetails>
                </Accordion>

            </>
        );
    }
    else {
        return <div />
    }

};

export default memo(FilterBar2);